<template>
  <vs-popup
    title="Atenção!"
    id="popup-finished"
    :active.sync="finalizePopupIsActive"
    @close="closePopup"
    class="sizePopup"
    z-index:999
  >
    <div class="w-full flex items-center mb-2" v-if="!isUserSummary">
      <div class="w-full text-center ml-1 mb-1">
        <b>Deseja encerrar o atendimento?</b>
      </div>
    </div>

    <!-- Caso esteja com a função de Pesquisa Obrigatória -->
    <div v-if="!finishWithSearch && !finishCommon">
      <vs-alert active="true" color="warning" class="no-message-alert mb-4">
        Não é possível realizar novas ações porque o atendimento está aguardando pesquisa.
      </vs-alert>
    </div>

    <!-- Métricas Inteligentes -->
    <div v-if="!isUserSummary ? reasons.length > 0 : summaryReasonInfo">
      <vs-divider>
        {{ isUserSummary ? 'Métrica Inteligente' : 'Selecione a Métrica Inteligente' }}
      </vs-divider>

      <vs-checkbox v-if="allowEmptyReason && !this.isUserSummary" v-model="ignoreReason" class="mb-4 mt-3">
        <span class="phone-number-span">Não Informar a Métrica Inteligente</span>
      </vs-checkbox>

      <v-select
        v-if="!ignoreReason && resetOptions"
        v-model="currentReasonId"
        class="w-full mb-4"
        label="description"
        :reduce="(option) => option.id"
        :options="reasons"
        :disabled="isUserSummary"
        @input="resetOptions">
      </v-select>

      <div v-if="currentReason && !ignoreReason">
        <vs-textarea
          counter="254"
          v-validate="'required'"
          v-if="currentReason.use_observation && currentReason.require_observation"
          name="observation" class="w-full" label="Observações" v-model="observation"
          :required="currentReason.require_observation"
          :disabled="isUserSummary"
        ></vs-textarea>

        <vs-textarea
          counter="254"
          v-else-if="currentReason.use_observation"
          :required="currentReason.require_observation"
          name="observation" class="w-full" label="Observações" v-model="observation"
          :disabled="isUserSummary"
        ></vs-textarea>

        <span class="text-danger text-sm mb-6" v-show="errors.has('observation')">
          Campo observação é obrigatório
        </span>
        <div class="clear"></div>

        <div>
          <component
            :index="index"
            :items="responses[index]"
            :description="currentReason.reason_options[index].description"
            v-for="(option, index) in options"
            @valueChanged="updateValue"
            :key="index"
            :is="option"
            :disabled="isUserSummary"
          />
        </div>
      </div>
    </div>

    <!-- Tipos de Encerramento -->
    <div v-if="(finishWithSearch || finishCommon) && summaryChatTicket !== null ? (summaryChatTicket.is_auto_finished ? false : !Boolean(summaryChatTicket.closed_by)) : true">
      <vs-divider>
        {{ isUserSummary ? 'Encerramento Escolhido' : 'Tipos de Encerramentos' }}
      </vs-divider>

      <ul class="messageflow mb-5 width-popup-finalize">
        <li class="flow-items">
          <vs-radio v-model="messageFlow" vs-name="messageFlow" vs-value="1" v-if="finishCommon || isUserSummary" :disabled="isUserSummary">
            Enviar mensagem de encerramento
          </vs-radio>
        </li>

        <li class="flow-items">
            <vs-radio v-model="messageFlow" vs-name="messageFlow" vs-value="2" v-if="finishWithSearch || isUserSummary" :disabled="isUserSummary">
              Enviar pesquisa de satisfação e mensagem de encerramento
            </vs-radio>
        </li>

        <li class="flow-items">
          <vs-radio v-model="messageFlow" vs-name="messageFlow" vs-value="3" v-if="finishWithSearch || isUserSummary" :disabled="isUserSummary">
            Enviar somente pesquisa de satisfação
          </vs-radio>
        </li>

        <li class="flow-items">
          <vs-radio v-model="messageFlow" vs-name="messageFlow" vs-value="4" v-if="finishCommon || isUserSummary" :disabled="isUserSummary">
            Somente encerrar o chamado
          </vs-radio>
        </li>

        <li class="flow-items">
          <vs-checkbox  v-if="messageFlow && ['2', '3'].includes(messageFlow)" v-model="multipleNps" :disabled="isUserSummary" class="m-0 mt-5">
            <span class="phone-number-span">Múltiplas Pesquisas</span>
          </vs-checkbox>
        </li>
      </ul>
    </div>

    <div v-if="summaryChatTicket !== null ? summaryChatTicket.is_auto_finished : false">
      <vs-divider>
        Encerramento Automático Usado
      </vs-divider>

      <ul class="messageflow mb-5 width-popup-finalize">
        <li class="flow-items">
          <vs-radio v-model="automaticFinishedOption" vs-value="1" disabled>
            Todos os Atendimentos em Aberto às 00:00
          </vs-radio>
        </li>

        <li class="flow-items">
          <vs-radio v-model="automaticFinishedOption" vs-value="2" disabled>
            Todas as Pesquisas de Satisfação em Aberto às 00:00
          </vs-radio>
        </li>

        <li class="flow-items">
          <vs-radio v-model="automaticFinishedOption" vs-value="3" disabled>
            Encerrar Atendimento por Inatividade
          </vs-radio>
        </li>
      </ul>
    </div>

    <div v-if="summaryChatTicket !== null ? (!Boolean(summaryChatTicket.closed_by) || !summaryChatTicket.is_auto_finished) : false">
      <vs-divider>
        Encerramento em Massa Usado
      </vs-divider>

      <ul class="messageflow mb-5 width-popup-finalize">
        <li class="flow-items">
          <vs-radio v-model="massiveFinishedOption" disabled vs-value="all">
            Atendimentos Abertos
          </vs-radio>
        </li>

        <li class="flow-items">
          <vs-radio v-model="massiveFinishedOption" disabled vs-value="old">
            Atendimentos de Dias Anteriores Abertos
          </vs-radio>
        </li>

        <li class="flow-items">
          <vs-radio v-model="massiveFinishedOption" disabled vs-value="user">
            Atendimentos de Usuários Específicos
          </vs-radio>
        </li>

        <li class="flow-items">
          <vs-radio v-model="massiveFinishedOption" disabled vs-value="instance">
            Atendimentos de Conexões Específicas
          </vs-radio>
        </li>

        <vs-divider class="mb-6"/>

        <li class="flow-items">
          <vs-radio v-model="massiveFinishedOption" disabled vs-value="inbox">
            Atendimentos da Caixa de Entrada
          </vs-radio>
        </li>

        <li class="flow-items">
          <vs-radio v-model="massiveFinishedOption" disabled vs-value="inbox_instance">
            Atendimentos da Caixa de Entrada por Conexão Específica
          </vs-radio>
        </li>

        <vs-divider class="mb-6"/>

        <li class="flow-items">
          <vs-radio v-model="massiveFinishedOption" disabled vs-value="many_attendances">
            Encerramento em Massa feito dentro do Chat
          </vs-radio>
        </li>
      </ul>
    </div>

    <div v-if="!isUserSummary">
      <vs-divider>
        Agendamento de Contato
      </vs-divider>

      <ul class="mb-4">

        <li class="flow-items">
          <div class="flex mb-4">
            <vs-switch v-model="contactSchedule.isUsed">
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
            <span class="ml-2">Agendar envio de Mensagem</span>
          </div>
        </li>

        <li v-if="contactSchedule.isUsed">

          <div class="flex flex-row justify-evenly" style="flex-direction: column;">

            <div>
              <div class="w-full flex justify-center items-center">
                <span class="phone-number-span">
                  Data de Envio
                </span>
              </div>
              <div class="w-full flex justify-center items-center">
                <flat-pickr
                  :config="configDatePicker"
                  v-model="contactSchedule.dateSend"
                  placeholder="Escolha uma Data"
                  v-validate="'required'"
                  name="dateSend"
                />
              </div>
              <span class="text-danger text-sm mb-6" v-show="errors.has('dateSend')">
                O campo data é obrigatório
              </span>
            </div>

            <div>
              <div class="w-full flex justify-center items-center">
                <span class="phone-number-span">
                  Horário do Envio
                </span>
              </div>
              <div class="w-full flex justify-center items-center">
                <flat-pickr
                  :config="configdateTimePicker"
                  v-model="contactSchedule.timeSend"
                  placeholder="Escolha um Horário"
                  v-validate="'required'"
                  name="timeSend"
                />
              </div>
              <span class="text-danger text-sm mb-6" v-show="errors.has('timeSend')">
                O campo horário é obrigatório
              </span>
            </div>
          </div>

          <div class="m-8 mb-5">
            <div v-if="currentInstance.is_official" >
              <select-message-template
                  :itemsPerPage="6"
                  :instance="currentInstance"
                  ref="select-message-template"
                  title="Selecione Modelo de Mensagens"
                  @on-select-template="selectTemplate"
              ></select-message-template>
            </div>
            <div v-else >
              <span>Mensagem a ser enviada:</span>
              <vs-textarea
                  v-model="contactSchedule.messageSend"
                  v-validate="'required'"
                  class="mb-0"
                  name="messageSend"
              />
              <span class="text-danger text-sm mb-6" v-show="errors.has('messageSend')">
                O campo de mensagem é obrigatório
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="text-center" v-if="!isUserSummary">
      <vs-button
        class="bg-primary-gradient ml-4"
        type="filled"
        @click="finalizeChat" color="primary">
        Confirmar
      </vs-button>
    </div>
  </vs-popup>
</template>
<script>

  import Vue             from '@/main'
  import vSelect         from 'vue-select'
  import { mapGetters }  from 'vuex'
  import {getTimeZone, instanceObject} from '@/utils'
  import reasonRequests  from '@/http/requests/reasons'
  import { ChatTicketService } from "@/db/chatTicket_service"
  import moduleSettings  from '@/store/settings/moduleSettings'
  import IntField        from '@/views/reason-response-fields/Int'
  import TextField       from '@/views/reason-response-fields/Text'
  import RadioField      from '@/views/reason-response-fields/Radio'
  import SelectField     from '@/views/reason-response-fields/Select'
  import BooleanField    from '@/views/reason-response-fields/Boolean'
  import DecimalField    from '@/views/reason-response-fields/Decimal'
  import CurrencyField   from '@/views/reason-response-fields/Currency'
  import CheckboxField   from '@/views/reason-response-fields/Checkbox'
  import { reasonType } from "@/supports/reasonSupport";
  import { finishChatTicket, finishChatTicketWithResearch, fetchReasonResponses} from '@/http/requests/chatTicket';

  import flatPickr from 'vue-flatpickr-component'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import 'flatpickr/dist/flatpickr.css'

  import {createContactSchedule} from '@/http/requests/contactSchedule'
  import selectMessageTemplate from "@/components/meta/SelectMessageTemplate.vue";

  export default {
    name: 'finalize-popup',
    components: {
      vSelect,
      flatPickr,
      IntField,
      TextField,
      RadioField,
      SelectField,
      DecimalField,
      BooleanField,
      CheckboxField,
      CurrencyField,
      selectMessageTemplate
    },
    provide() {
      return {
        $validator: this.$validator,
      }
    },
    data() {
      return {
        reasons: [],
        options: [],
        responses: [],
        reasonResponses: [],
        messageFlow: null,
        noMessage: false,
        chatTicket: null,
        observation: null,
        finishReason: null,
        multipleNps: false,
        ignoreReason: false,
        currentReasonId: null,
        summaryChatTicket: null,
        massiveFinishedOption: null,
        finalizePopupIsActive: false,
        automaticFinishedOption: null,
        configDatePicker: {
          enableTime: false,
          noCalendar: false,
          time_24hr: true,
          dateFormat: 'd/m/Y',
          minDate: new Date()
        },
        configdateTimePicker: {
          enableTime: true,
          noCalendar: true,
          time_24hr: true
        },
        contactSchedule: {
          dateSend: '',
          timeSend: '',
          messageSend: '',
          isUsed: false
        },
        templateMessage: {
          selectedTemplate: [],
          templateParameters: []
        },
        summaryReasonInfo: null
      }
    },
    created () {
      this.$events.off('setReasonFromUsersProfile')
      this.$events.on('setReasonFromUsersProfile', async (reason, chatTicket) => {
        this.finalizePopupIsActive = true;
        this.summaryChatTicket     = chatTicket;

        if (reason !== null) {
          this.summaryReasonInfo = await reason;
          this.currentReasonId   = this.summaryReasonInfo.reason_id;

          this.$store.dispatch('setShowLoadingOverlay', false);
          this.open();
          this.loadReasons();
        }

        this.multipleNps = chatTicket.is_multiple_research;
        this.messageFlow = this.setFinishOptionChosen(chatTicket);
        this.massiveFinishedOption = chatTicket.closed_by;
        if (chatTicket.is_auto_finished) {
          this.automaticFinishedOption = this.setAutomaticFinishOption(chatTicket);
        }
      });

      if (!moduleSettings.isRegistered) {
        this.$store.registerModule('settings', moduleSettings);
        moduleSettings.isRegistered = true;
      }
    },
    computed: {
      customerLastChat() {
        return (this.chatContact && this.chatContact.customerLastChat) ? this.chatContact.customerLastChat : null
      },
      chatActives() {
        return this.$store.state.chat.chatActives
      },
      currentReason () {
        return this.reasons.filter((reason) => {
          return reason.id === this.currentReasonId
        })[0]
      },
      chatContact() {
        return this.$store.state.chatContact.chatFinalizePopup
      },
      activeUserInfo() {
        return this.$store.state.AppActiveUser;
      },
      allowEmptyReason(){
        return !!parseInt(this.settings().allow_close_ticket_without_reason)
      },
      isMandatoryResearch(){
        return !!parseInt(this.settings().is_mandatory_research)
      },
      finishWithSearch(){
        return this.customerLastChat && (this.customerLastChat.chatTicket || this.customerLastChat.chat_ticket_id) && !this.chatContact.is_research
      },
      finishCommon(){
        return !this.isMandatoryResearch || this.activeUserInfo.role.name === "administrador"
      },
      currentInstance(){
        return this.chatContact ? instanceObject(this.chatContact.instance_id) : null
      },
      isUserSummary() {
        return !(this.summaryReasonInfo === null) || !(this.summaryChatTicket === null);
      }
    },
    watch: {
      '$store.state.chatContact.finalizePopupIsActive': async function (val) {
        if (val) {
          this.$store.dispatch('setShowLoadingOverlay', false)
          this.open()
          this.loadReasons();
        }

        this.finalizePopupIsActive = val
      }
    },
    methods: {
      ...mapGetters({
        'settings': 'settings/settings'
      }),
      closePopup() {
        if (this.isUserSummary) {
          this.messageFlow = null;
          this.multipleNps = false;
          this.summaryChatTicket = null;
          this.summaryReasonInfo = null;
          this.automaticFinishedOption = null;
        }

        this.$store.dispatch('chatContact/changeStatusFinalizePopupActive', false);
      },
      selectTemplate(args){
        this.templateMessage.selectedTemplate = args.selectedTemplate
        this.templateMessage.templateParameters = args.templateParameters
      },
      updateValue (index, itemIndex, value) {
        let opts = {
          reason_option_is_required: this.responses[index][itemIndex].reason_option_is_required,
          reason_option_item_id: this.responses[index][itemIndex].reason_option_item_id,
          reason_option_id: this.responses[index][itemIndex].reason_option_id,
          description: this.responses[index][itemIndex].description,
          value: value.toString()
        }
        let list = this.responses[index]
        list.splice(itemIndex, 1, opts)
        this.responses.splice(index, 1, list)
      },
      async finalizeChat() {
        if (await this.validade()) {
          this.$vs.loading()
          setTimeout( ()=> {
            this.$vs.loading.close()
          }, 2000);

          const args = this.prepareFinish();
          if (!args) { return; }

          if (this.contactSchedule.isUsed) {
            await this.createContactSchedule();
          }
          if (parseInt(this.messageFlow) === 2 || parseInt(this.messageFlow) === 3) {

            this.customerServiceClose = false;
            await this.$store.dispatch('setShowLoadingOverlay', true);
            const ctService = new ChatTicketService();
            await ctService.closingTicket(this.chatContact.id);
            Vue.$events.fire('NotificationsLabels', { label: 'research', item: this.chatContact });
            this.finishedTicketsWithResearch(args);
            await this.$store.dispatch('chatContact/changeStatusFinalizePopupActive', false);
            await this.$store.dispatch('setShowLoadingOverlay', false);
          }
          if (parseInt(this.messageFlow) === 4 || parseInt(this.messageFlow) === 1){
            return this.onlyFinishChatTicket(args)
          }
        }
      },

      async createContactSchedule(){
        let slicedDate = (this.contactSchedule.dateSend).split('/');

        const newDate = slicedDate[2] + '-' + slicedDate[1] + '-' + slicedDate[0];
        const hour = this.checkCurrentDate(this.contactSchedule.timeSend).substring(0, 5);
        const newTime = getTimeZone(hour, 'schedules', false);

        const data = {
          instance_id: this.chatContact.instance_id,
          customer_id: this.chatContact.customer.id,
          user_id: this.chatContact.user.id,
          date_send: newDate,
          time_send: newTime,
          text_message: this.contactSchedule.messageSend,
          message_template_name: this.templateMessage.selectedTemplate.name,
          message_template_id: this.templateMessage.selectedTemplate.meta_id,
          official_params: this.templateMessage.templateParameters,
        }

        createContactSchedule(data).then(() => {
          this.contactSchedule = {
            dateSend: '',
            timeSend: '',
            messageSend: '',
            isUsed: false
          }

          if (this.checkIfTheTimeIsPast(newTime, data.date_send)) {
            this.$vs.notify({
              time: 15000,
              color: 'primary',
              title: 'Aviso',
              text: 'Esse agendamento será disparado no dia seguinte, todos os agendamentos para horários passados serão reagendados para o próximo dia!'
            });
          }
          return this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'O agendamento foi realizado com Sucesso!',
          });
        }).catch((error) => {
          console.error(error);
          return this.$vs.notify({
            color: 'danger',
            title: 'Erro',
            text: 'Houve algum erro ao agendar o contato!'
          });
        })
      },

      checkCurrentDate(scheduleDate) {
        const date = new Date();
        const current = (String(date.getHours()).length === 2 ? date.getHours() :  '0' + date.getHours()) + ':' + (String(date.getMinutes()).length === 2 ? date.getMinutes() : '0' + date.getMinutes());

        if (current === scheduleDate) {
          if (scheduleDate === '23:59') {
            return '00:00:00';
          }
          else if ((parseInt(scheduleDate.split(':')[1]) + 1) === 60) {
            let result = String(parseInt(scheduleDate.split(':')[0]) + 1).length === 1 ? '0' + String(parseInt(scheduleDate.split(':')[0]) + 1) : String(parseInt(scheduleDate.split(':')[0]) + 1);
            return  result + ':00:00';
          } else {
            let result = String(parseInt(scheduleDate.split(':')[1]) + 1).length === 1 ? '0' + String(parseInt(scheduleDate.split(':')[1]) + 1) : String(parseInt(scheduleDate.split(':')[1]) + 1);
            return scheduleDate.split(':')[0] + ':' + result + ':00';
         }
        } else {
          return scheduleDate + ":00";
        }
      },

      checkIfTheTimeIsPast(newTime, dateSend) {
        const date = new Date();
        if (newTime < date.toString().split(' ')[4] && date.toISOString().split('T')[0] === dateSend) {
          return true;
        }
        return false;
      },

      finishedTicketsWithResearch(args) {
        finishChatTicketWithResearch(args)
        .then((response) => {
          const chatContact = response.data.data.finishChatTicketWithResearch

          this.$store.dispatch('setShowLoadingOverlay', true)
          this.$store.dispatch('chat/chatActives', this.chatActives - 1)
          this.$store.commit('chatContact/UPDATE_CHAT_CONTACT', chatContact)
          this.$emit('resetActiveChatUser');
          this.messageFlow = null;

          return this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'Pesquisa enviada com sucesso!'
          })
        }).catch((error) => {
          this.$store.dispatch('setShowLoadingOverlay', false)
          console.error(error)
        })
      },

      onlyFinishChatTicket(args) {
        finishChatTicket(args)
        .then((response) => {
          this.$store.dispatch('setShowLoadingOverlay', true)
          const chatContact = response.data.data.finishChatTicket
          this.$store.commit('chatContact/UPDATE_CHAT_CONTACT', chatContact)
          this.$emit('resetActiveChatUser');
          this.messageFlow = null;
          return this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'Esse atendimento foi encerrado com sucesso!'
          })
        }).catch((error) => {
          this.$store.dispatch('setShowLoadingOverlay', true)
          console.error(error)
        })
        this.$store.dispatch('chatContact/changeStatusFinalizePopupActive', false);
      },

      loadReasonResponses() {
        const chatTicketId = this.summaryReasonInfo ? this.summaryReasonInfo.chat_ticket_id : this.chatContact.id;
        fetchReasonResponses(null, chatTicketId)
          .then((response) => {
            this.reasonResponses = response.data.data.reasonResponses[0]
            this.$store.dispatch('setShowLoadingOverlay', false)
            this.prepareOptionsResponses()
          })
          .catch((error) => {
            console.error(error)
            this.$store.dispatch('setShowLoadingOverlay', false)
          })
      },

      loadReasons() {
        this.$store.dispatch('setShowLoadingOverlay', true)

        reasonRequests.fetch({deleted: false, type: reasonType})
          .then((response) => {
            this.reasons = response.data.data.reasons;
            this.$store.dispatch('setShowLoadingOverlay', false)
            this.loadReasonResponses();
          })
          .catch((error) => {
            this.$store.dispatch('setShowLoadingOverlay', false)
            console.error(error)
          })
      },

      prepareOptionsResponses(){
        if(!this.reasonResponses){
          return;
        }

        let reasonId = this.reasonResponses.reason_id
        let observation = this.reasonResponses.observation
        let reasonOption = this.reasonResponses.reason_option

        let hasReason = this.reasons.filter((reason) => {
          return reason.id === reasonId
        })[0]

        if (!hasReason) {
          return;
        }

        this.currentReasonId = reasonId
        this.resetOptions()
        this.loadOptionsResponses(observation, reasonOption)
      },

      loadOptionsResponses(observation, reasonOption){
        let currentOptions = this.currentReason.reason_options
        if (!currentOptions) { return; }

        // Define a observação da Métrica Inteligente
        this.observation = !observation.includes('null') ? observation : null

        reasonOption.forEach((option) => {
          //Busca o index da opção que está sendo lida no momento
          let reasonOptionIndex = currentOptions.findIndex((e) => {
            return e.id == option.id
          })

          if(reasonOptionIndex === -1){ return; }

          //Busca o index do valor da opção que foi lida
          let reasonItemIndex = currentOptions[reasonOptionIndex].reason_option_items.findIndex((e) => {
            return e.id == option.option_item_id
          })

          reasonItemIndex = reasonItemIndex !== -1 ? reasonItemIndex : 0

          // Popula o valor das opções
          if ( option.type == "select" || option.type == "radio" ){
            this.updateValue(reasonOptionIndex, reasonItemIndex, true)
          } else {
            this.updateValue(reasonOptionIndex, reasonItemIndex, option.value)
          }

          if (option.type == "checkbox") {
            option.value.split(',').forEach((value) => {
              reasonItemIndex = currentOptions[reasonOptionIndex].reason_option_items.findIndex((e) => {
                return e.description == value
              })
              if (reasonItemIndex !== -1) { this.updateValue(reasonOptionIndex, reasonItemIndex, true) }
            })
          }
        })
      },

      resetOptions() {
        this.options = []
        this.responses = []
        this.reasonResponses = []

        if (!this.currentReason) {
          return
        }

        if (!this.currentReason.reason_options) {
          return
        }

        if (this.currentReason.reason_options.length == 0) {
          return
        }

        this.currentReason.reason_options.forEach((opt, idx) => {
          let defaultValue = null

          if (opt.reason_option_kind.tag === 'text') {
            this.options.push(TextField)
          }

          if (opt.reason_option_kind.tag === 'int') {
            this.options.push(IntField)
            defaultValue = "0"
          }

          if (opt.reason_option_kind.tag === 'currency') {
            this.options.push(CurrencyField)
            defaultValue = "0"
          }

          if (opt.reason_option_kind.tag === 'decimal') {
            this.options.push(DecimalField)
            defaultValue = "0"
          }

          if (opt.reason_option_kind.tag === 'select') {
            this.options.push(SelectField)
          }

          if (opt.reason_option_kind.tag === 'radio') {
            this.options.push(RadioField)
            defaultValue = "false"
          }

          if (opt.reason_option_kind.tag === 'checkbox') {
            this.options.push(CheckboxField)
            defaultValue = "false"
          }

          if (opt.reason_option_kind.tag === 'boolean') {
            this.options.push(BooleanField)
            defaultValue = "false"
          }

          let items = [null]
          if (opt.reason_option_items && opt.reason_option_items.length > 0) {
            items = opt.reason_option_items
          }

          items.forEach((item) => {
            let itemId = null
            let itemDescription = null
            this.responses[idx] = this.responses[idx] ? this.responses[idx] : []

            if (item) {
              itemId = item.id
              itemDescription = item.description
            }

            this.responses[idx].push({
              reason_option_id: opt.id,
              reason_option_is_required: opt.is_required,
              reason_option_item_id: itemId,
              description: itemDescription,
              value: defaultValue
            })
          })
        })
      },

      prepareFinish(){
        let noSendMessage = [2, 4].includes(parseInt(this.messageFlow))
        let args = {
          id: this.chatContact.id,
          noMessage: noSendMessage,
          reasonId: this.finishReason,
          observation: this.observation,
          reason_responses: this.responses,
          isMultipleResearch: this.multipleNps
        }

        if (this.currentReason) { args['reasonId'] = this.currentReason.id }
        if (this.ignoreReason) { args['reasonId'] = null }

        if (!parseInt(this.messageFlow)){
          this.$vs.notify({
              color: 'warning',
              title: 'Ops!',
              text: 'Informe um Tipo de Encerramento antes de continuar!'
            }); return null;
        }

        if (
          this.reasons.length > 0 && (
            args['reasonId'] == null && !this.ignoreReason
          )
        ) {
            this.$vs.notify({
              color: 'warning',
              title: 'Ops!',
              text: 'Informe uma Métrica Inteligente antes de continuar!'
            });

            return null;
        }

        return args;
      },

      async validade(){
        let main = await this.$validator.validateAll().then(result => {
          return result;
        });

        let childs = this.$children.map( async child => {
            return await child.$validator.validateAll();
        });

        childs = await Promise.all(childs).then( results => { return results; })
        return main && !childs.includes(false);
      },
      open() {
        this.reasons = []
        this.reasonResponses = []
        this.opened = true
        this.messageFlow = null
        this.observation = null
        this.finishReason = null
        this.observation = null
        this.currentReasonId = null
        this.ignoreReason = false
        this.multipleNps = false

        this.contactSchedule = {
          dateSend: '',
          timeSend: '',
          messageSend: '',
          isUsed: false
        }

        this.templateMessage = {
          selectedTemplate: [],
          templateParameters: []
        }
      },
      setFinishOptionChosen(chatTicket) {
        return chatTicket.grade_at === null
        ? (chatTicket.send_finished_message || chatTicket.finished_message_is_sent ? '1' : '4')
        : (chatTicket.send_finished_message || chatTicket.finished_message_is_sent ? '2' : '3');
      },
      setAutomaticFinishOption(chatTicket) {
        return (chatTicket.closed_by === 'inactivity' ? '3' : (chatTicket.closed_by === 'search' ? '2' : '1'));
      }
    }
  }
</script>


<style lang="scss">
  .vs-tooltip {
    z-index: 99999999999!important
  }

  #popup-finished{
    .width-popup-finalize{
      display: block;

      .flow-items{
        margin-bottom: 5px;
      }
    }
  }

</style>

<style>
.sizePopup {
  width: 100%;
  height: 100%;
}
</style>
